import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=41e3b3b3&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=js&"
export * from "./Counter.vue?vue&type=script&lang=js&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=41e3b3b3&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e3b3b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e3b3b3')) {
      api.createRecord('41e3b3b3', component.options)
    } else {
      api.reload('41e3b3b3', component.options)
    }
    module.hot.accept("./Counter.vue?vue&type=template&id=41e3b3b3&scoped=true&", function () {
      api.rerender('41e3b3b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContentHeader/Counter.vue"
export default component.exports